import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { BUY_DOWN_ACTION_TYPE } from '../actions';

const initialState = {};

const buyDownsReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case BUY_DOWN_ACTION_TYPE.GET_BUY_DOWNS:
        return payload || initialState;

      case BUY_DOWN_ACTION_TYPE.CREATE_BUY_DOWN:
      case BUY_DOWN_ACTION_TYPE.EDIT_BUY_DOWN:
        draft[payload.id] = payload;
        break;

      case BUY_DOWN_ACTION_TYPE.DELETE_BUY_DOWN:
        delete draft[meta.id];
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default buyDownsReducer;
